import { useCallback, useEffect } from "react";
import { PROD_URL } from "@app/util/constant";
import useOutBrainScript from "@hooks/useOutBrainScript";
import { cn } from "@util/helpers";

export type OutBrainWidgetProps = {
  articleUrl: string;
  widgetId: string;
  /** The classname that will be added to the root of the component. */
  className?: string;
  /** Additional attributes, useful when adding data attributes. */
  dataAttributes?: { [key: `data-${string}`]: string };
};

export default function OutBrainWidget({
  articleUrl,
  widgetId,
  className,
  dataAttributes,
}: OutBrainWidgetProps): React.ReactElement {
  useOutBrainScript();

  const embedOutbrain = useCallback(() => {
    if (typeof window === "undefined") return;

    if (window.OBR) {
      window.OBR.extern.researchWidget();
    } else {
      setTimeout(embedOutbrain, 50);
    }
  }, []);

  useEffect(() => {
    embedOutbrain();
  }, [embedOutbrain]);

  return (
    <div
      className={cn("no-print OUTBRAIN", className)}
      data-src={`${PROD_URL}${articleUrl}`}
      data-widget-id={widgetId}
      data-ob-template="BusinessTimes"
      data-testid="outbrain-widget-component"
      {...dataAttributes}
    ></div>
  );
}
